exports.BookingStates = {
  ACTIVE: 'ACTIVE',
  ACCEPTED: 'ACCEPTED',
  CANCELLED: 'CANCELLED',
  CREATED: 'CREATED',
  DECLINED: 'DECLINED',
  EXECUTED: 'EXECUTED',
  EXPIRED: 'EXPIRED',
  GUEST_CLIENT_ACTION_NEEDED: 'GUEST_CLIENT_ACTION_NEEDED',
  GUEST_UPDATE_NO_AUTH: 'GUEST_UPDATE_NO_AUTH',
  GUEST_UPDATE_REQUESTED: 'GUEST_UPDATE_REQUESTED',
  HOST_UPDATE_NO_CAPTURE: 'HOST_UPDATE_NO_CAPTURE',
  HOST_UPDATE_REQUESTED: 'HOST_UPDATE_REQUESTED',
  INQUIRED: 'INQUIRED',
  NO_AUTH: 'NO_AUTH',
  NO_CAPTURE: 'NO_CAPTURE',
  NO_PAYMENT: 'NO_PAYMENT',
  OFFER_CLOSED: 'OFFER_CLOSED',
  OFFER_NO_CAPTURE: 'OFFER_NO_CAPTURE',
  OFFER_DECLINED: 'OFFER_DECLINED',
  OFFER_EXPIRED: 'OFFER_EXPIRED',
  OFFER_SUBMITTED: 'OFFER_SUBMITTED',
  OFFER_WITHDRAWN: 'OFFER_WITHDRAWN',
  PRE_BOOKED: 'PRE_BOOKED',
  REQUESTED: 'REQUESTED',
  SETTLED: 'SETTLED',
  SETTLE_BALANCE_REQUIRED: 'SETTLE_BALANCE_REQUIRED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  WITHDRAWN: 'WITHDRAWN'
};
